<template>
  <div>
    <nav-bar></nav-bar>
      <div class="top-level">
      <section class="calendar-container">
        <calendar-view
          :events="events"
          class="theme-default"
          :show-date="showDate"
          :display-period-uom="displayPeriodUom"
          :display-period-count="displayPeriodCount"
          @click-date="navigateTo"
        >
          <calendar-view-header
            slot="header"
            @input="setShowDate"
            slot-scope="{ headerProps }"
            :header-props="headerProps">
          </calendar-view-header>
        </calendar-view>
      </section>
    </div>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader, CalendarMathMixin } from 'vue-simple-calendar';
import router from '@/router';
import { getEngagements } from '@/utils/api';

require('vue-simple-calendar/static/css/default.css');

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  mixins: [CalendarMathMixin],
  async mounted() {
    console.log('mounted')
    this.engagements = await getEngagements();
    // get events for calendar from database
  },
  data() {
    return {
      showDate: this.thisMonth(1),
      displayPeriodUom: 'month',
      displayPeriodCount: 1,
      useDefaultTheme: true,
      engagements: [],
    };
  },
  methods: {
    thisMonth(d, h, m) {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0);
    },
    setShowDate(d) {
      console.log('setting show date', d)

      this.showDate = d;
    },
    navigateTo(date) {
      router.push({ name: 'leads-day', params: { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() } });
    },
  },
  computed: {
    events() {
      return this.engagements.map(e => ({
        id: e.engagement.engagement_id,
        startDate: e.engagement.occurred_on,
        endDate: e.engagement.occurred_on,
        title: e.lead.name,
      }));
    },
  },
};
</script>

<style scoped>
.top-level {
 display: flex;
  flex-direction: row;
  width: 95vw;
  min-width: 30rem;
  max-width: 100rem;
  min-height: 40rem;
  margin-left: auto;
  margin-right: auto;
}

.calendar-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 80vh;
  background-color: white;
}
</style>
